<template>
	<div>
		<van-nav-bar title="关于我们"  fixed placeholder left-arrow @click-left="onClickLeft"  @click-right="onClickRight()">
		  <template #right>
		      <van-icon name="service-o"  size="28"  color="orange" />
		    </template>
		</van-nav-bar>
		<div class="nav">
			  <van-cell title="常见问题"  is-link  icon="award-o"  @click="problem()" />
			  <van-cell title="个人信息保护及隐私政策"  is-link  icon="friends-o"  @click="protocol()" />
			  <van-cell title="平台使用协议"  is-link  icon="coupon-o"  @click="electronic()" />
			  <van-cell title="用户注册及使用APP隐私协议"  is-link  icon="manager-o"  @click="userregistration()" />
		</div>
		
	</div>
	
</template>
<script>
	import {
		NavBar,
		Cell,
		Icon,	
	} from "vant";
	export default {
		name: "aboutUs",
		data() {
			return {
				// accountid: localStorage.getItem("accountUid"),
				provisions: true,
				customerServicePhone:""
			};
		},
		created() {
			this.service()
		},
		methods: {
			// 联系客服
			onClickRight(){
			  	window.open("app:/#/call_driver?" + this.customerServicePhone + "&service");
		    },
			service(){
				this.$axios({
					url: "/vedm/accountApp/accountInformation/"+localStorage.getItem("accountUid")+"/"+localStorage.getItem("key"),
					method: "get",
					headers: {
						Authorization: localStorage.getItem('token') //token换成从缓存获取
					},
				}).then(res => {
					this.customerServicePhone=res.data.data.customerServicePhone
				}).catch(function (error) {
					console.log(error)
                    window.app.showReLoginDialog()
				  });
				},
			onClickLeft() {
				window.open("app:/#/finish")
			},
			problem() {
				this.$router.push({
					name: "problem",
					params: {
						returtlist: '1',

					},
				});
			},
			protocol() {
				this.$router.push({
					name: "electronic",
					params: {
						returtlist: '1',

					},
				});
			},
			electronic() {
				this.$router.push({
					name: "platformusage",
					params: {
						returtlist: '1',

					},
				});
			},
			userregistration() {
				this.$router.push({
					name: "userregistration",
					params: {
						returtlist: '1',
					},
				});
			}
		},
		components: {
			"van-nav-bar": NavBar,
			"van-icon":Icon,
			"van-cell": Cell
			
		}
	};
</script>
<style scoped lang="less">
	.swiperImg {
		width: 375px;
		height: 144px;
		object-fit: cover;
	}

	.nav {
		height: 111px;
		margin-top: 17px;
		padding: 0 11px;

		p {
			margin: 0 0 20px 0;
			font-size: 18px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: rgba(33, 37, 41, 1);
		}

		.navItem {
			padding: 0 10px;
			display: flex;
			text-align: center;
			justify-content: space-between;

			span {
				display: block;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: rgba(33, 37, 41, 1);
			}
		}
		
	}
	.assess-box{
		
		
	}
</style>
